import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Box from "@mui/material/Box";
import { modifyOrganization, addOrganization } from "../../domain/apis/organizationService";
import _ from "lodash";
import { useEffect, useState } from "react";
import { FormUIItem } from '../commons';

function OrganizationModifyComponent({ show, handleClose, data }) {
  const [formUI, setFormUI] = useState({});
  const [error, setError] = useState({});

  useEffect(() => {
    setError({});
  }, [show]);

  useEffect(() => {
    if (!data) {
      setFormUI({});
    } else {
      setFormUI(data);
    }
  }, [data, show]);

  const handleUpdateForm = (key, value) => {
    let obj = {};
    obj[key] = value;
    setFormUI({
      ...formUI,
      ...obj,
    })
  };

  const validateForm = () => {
    var result = true;
    var errorState = {};

    if (!formUI["name"] || formUI["name"] === '') {
      result = false;
      errorState.name = true;
    }

    if (!formUI["code"] || formUI["code"] === '') {
      result = false;
      errorState.code = true;
    }

    setError(errorState);
    return result;
  }

  const onModify = () => {
    if (!validateForm()) {
      return;
    }

    if (data) {
      modifyOrganization(formUI).subscribe({
        next: ({ data }) => {
          handleClose(true);
        },
      });
      return;
    }
    addOrganization(formUI).subscribe({
      next: ({ data }) => {
        handleClose(true);
      },
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => handleClose()}
        centered
        style={{ zIndex: 10000 }}
      >
        <Modal.Header>
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            {data && <Modal.Title>Chỉnh sửa Giáo Phận</Modal.Title>}
            {!data && <Modal.Title>Thêm Giáo Phận</Modal.Title>}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              <FormUIItem
                label={"Tên"}
                code={"name"}
                required
                error={_.get(error, "name")}
                errorMessage={"Vui lòng nhập nội dung!"}
                initValue={_.get(data, "name")}
                handleUpdate={handleUpdateForm} />
              <FormUIItem
                label={"Mã"}
                code={"code"}
                required
                error={_.get(error, "code")}
                errorMessage={"Vui lòng nhập nội dung!"}
                initValue={_.get(data, "code")}
                handleUpdate={handleUpdateForm} />
                <FormUIItem
                label={"Email"}
                code={"email"}
                initValue={_.get(data, "email")}
                handleUpdate={handleUpdateForm} />
                <FormUIItem
                label={"Số ĐT"}
                code={"phone"}
                initValue={_.get(data, "phone")}
                handleUpdate={handleUpdateForm} />
              <FormUIItem
                label={"Mô tả"}
                code={"description"}
                initValue={_.get(data, "description")}
                handleUpdate={handleUpdateForm} />
            </Box>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Hủy
          </Button>
          <Button variant="primary" onClick={() => onModify()}>
            Lưu
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OrganizationModifyComponent;
